import { Button, Spin, Tooltip } from 'antd'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Wrapper } from './styled'

interface IProps {
  primaryText?: string
  primaryAction?: () => void
  disablePrimaryButton?: boolean
  primaryTooltip?: string
  secondaryText: string
  secondaryAction: () => void
  disableSecondaryButton?: boolean
  secondaryIsPrimary?: boolean
  isDangerous?: boolean
  processing?: boolean
  iconPrimary?: IconProp
  iconPrimaryPosition?: 'start' | 'end'
  iconSecondary?: IconProp
}

export const ModalButtons = ({
  primaryText,
  primaryAction,
  disablePrimaryButton,
  primaryTooltip,
  secondaryText,
  secondaryAction,
  disableSecondaryButton,
  secondaryIsPrimary = false,
  isDangerous = false,
  processing = false,
  iconPrimary,
  iconPrimaryPosition = 'end',
  iconSecondary,
}: IProps) => {
  return (
    <Wrapper
      isdangerous={String(isDangerous)}
      secondaryIsPrimary={String(secondaryIsPrimary)}
    >
      <Button disabled={disableSecondaryButton} onClick={secondaryAction}>
        {secondaryText}
        {iconSecondary && <FontAwesomeIcon icon={iconSecondary} />}
      </Button>
      {primaryAction && (
        <Spin spinning={processing}>
          <Tooltip
            title={primaryTooltip}
            getPopupContainer={() =>
              document.getElementById('lmsPage') as HTMLElement
            }
          >
            <Button disabled={disablePrimaryButton} onClick={primaryAction}>
              {iconPrimary && iconPrimaryPosition === 'start' ? (
                <FontAwesomeIcon icon={iconPrimary} />
              ) : null}
              {primaryText}
              {iconPrimary && iconPrimaryPosition === 'end' ? (
                <FontAwesomeIcon icon={iconPrimary} />
              ) : null}
            </Button>
          </Tooltip>
        </Spin>
      )}
    </Wrapper>
  )
}
